// DreamBook frontend version — manually incremented on every deploy.
//
// Convention: two-level X.YZ where YZ increments by 1 on every update
// (so 1.00 → 1.01 → 1.02 → ... → 1.99 → 2.00 → 2.01 → ...).
//
// Surfaced top-right of every page (next to the user menu) so the
// author can confirm they're looking at the right build after a
// refresh. Bump this constant in the SAME commit as the user-visible
// change so the version displayed always matches what shipped.
export const APP_VERSION = "3.43";
